<template>
  <div class="create-batch-check-order-job">
    <a-spin :spinning="loading">
      <div class="content flex-ct between" style="min-height: 0">
        <a-tabs default-active-key="OrderStatusFlow" @change="changeTabs">
          <a-tab-pane key="BaseInfo" :tab="$t(`基本信息`)"></a-tab-pane>
          <a-tab-pane key="AmountInfo" :tab="$t(`金额信息`)"></a-tab-pane>
          <a-tab-pane key="ProductInfo" :tab="$t(`明细`)"></a-tab-pane>
        </a-tabs>
        <div class="flex-ct" v-show="!loading">
          <OperateBtn
            v-if="$store.getters.hasFunction('payable_review') && formData.status === 'WAIT_CHECK'"
            api="operateDoc"
            :text="$t('审核')"
            :params="{
              action: 'check',
              docType,
              idList: [id],
            }"
            @success="init"
          />
          <PushBtn
            v-if="formData.status === 'WAIT_PAY' || formData.status === 'PART_PAID'"
            class="ml10"
            :docType="docType"
            :selectedRows="[formData]"
          />
          <FindRelatedDocBtn class="ml10" :id="id" :docType="docType" v-if="isDetail" />
          <OperateBtn
            class="ml10"
            v-if="isDetail && ['DRAFT', 'WAIT_CHECK', 'WAIT_PAY'].includes(formData.status)"
            api="cancelPaymentRequest"
            :text="$t('作废')"
            type="danger"
            :params="{
              idList: [id],
            }"
            @success="init"
          />
        </div>
      </div>
      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData">
            <ModalBox
              id="BaseInfo"
              :title="$t('基本信息')"
              :showCopy="isDetail"
              @copyOrder="copyOrder"
            >
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`付款申请单号`)">
                    <a-input disabled v-model="formData.paymentRequestSn"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`单据类型`)" required>
                    <SelectDocumentType
                      :docType="docType"
                      :code.sync="formData.orderType"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算组织`)" required>
                    <CommonSelect
                      :isBu="true"
                      :list="$store.state.settlementBuList"
                      :disabled="isDisabled"
                      :code.sync="formData.businessUnitCode"
                      :name.sync="formData.businessUnitName"
                      @change="changeBU"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`请款时间`)" required>
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.applyTime"
                      @choose="chooseDate"
                      :disabled="isDisabled"
                      :placehold="$t(`请款时间`)"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <CommonPayeeSelect
                    :orderType="formData.orderType"
                    :type.sync="formData.payeeType"
                    :code.sync="formData.payeeCode"
                    :name.sync="formData.payeeName"
                    :disabled="isDisabled"
                    :businessUnitCode="formData.businessUnitCode"
                  />
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`请款事由`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.applyReason"
                      :placeholder="$t(`请款事由`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`备注`)">
                    <a-input
                      :disabled="isDisabled"
                      v-model="formData.remark"
                      :placeholder="$t(`备注`)"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t(`状态`)">
                    <a-input
                      disabled
                      v-model="paymentRequestStatusMapping[formData.status]"
                    ></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
            <ModalBox id="AmountInfo" :title="$t('金额信息')">
              <a-row :gutter="16">
                <a-col :span="6">
                  <a-form-model-item :label="$t(`结算货币`)" required>
                    <SelectCurrency
                      :code.sync="formData.settlementCurrency"
                      :disabled="isDisabled"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`应付金额`)">
                    <PriceInput
                      disabled
                      :value="formData.payableAmount"
                      :currency="formData.settlementCurrency"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`付款货币`)" required>
                    <SelectCurrency :code.sync="formData.paymentCurrency" :disabled="isDisabled" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`预计应付金额`)">
                    <PriceInput
                      disabled
                      :value="formData.expectedPaymentAmount"
                      :currency="formData.paymentCurrency"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t(`请款金额`)" required>
                    <PriceInput
                      :disabled="isDisabled"
                      :value.sync="formData.applyAmount"
                      :currency="formData.settlementCurrency"
                      :placeholder="$t(`请款金额`)"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
          </a-form-model>
          <ModalBox id="ProductInfo" :title="$t('明细')">
            <template v-slot:header>
              <div class="option-btns pr20" v-if="!isDisabled">
                <span class="text-link fz16" @click="addLineHandle">
                  {{ $t('增行') }}
                </span>
                <span class="text-link fz16 ml20" @click="deleteLineHandle">
                  {{ $t('删行') }}
                </span>
              </div>
            </template>
            <CommonTable
              :columns="columns"
              :dataSource="showTableList"
              :scroll="{ x: 1200 }"
              :showPagination="false"
              :showSetting="false"
              :showSelect="!isDisabled"
              :selectedRowKeys.sync="selectedRowKeys"
            >
              <template v-slot:no="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:paymentPurpose="{ record }">
                <CommonSelect
                  :disabled="isDisabled"
                  :list="payment_purpose"
                  :code.sync="record.paymentPurpose"
                  :currency="formData.settlementCurrency"
                />
              </template>
              <template v-slot:applyAmount="{ record }">
                <PriceInput
                  :value.sync="record.applyAmount"
                  :currency="formData.settlementCurrency"
                  :disabled="isDisabled"
                  @blur="(val) => handleChange(val, record)"
                />
              </template>
              <template v-slot:payableAmount="{ text }">
                <PriceInput :value="text" :currency="formData.settlementCurrency" :showTxt="true" />
              </template>
              <template v-slot:expectedPaymentAmount="{ text }">
                <PriceInput :value="text" :currency="formData.paymentCurrency" :showTxt="true" />
              </template>
              <template v-slot:dueDate="{ record }">
                <DatePicker
                  :needhms="false"
                  style="background-color: #ffffff; width: 100%"
                  :init-date-time="record.dueDate"
                  @choose="
                    (data) => {
                      chooseDueDate(record, data)
                    }
                  "
                  :disabled="isDisabled"
                />
              </template>
              <template v-slot:settlementMethod="{ record }">
                <SelectSettlementMethod
                  :placeholder="$t(`结算方式`)"
                  :code.sync="record.settlementMethod"
                  :disabled="isDisabled"
                />
              </template>
            </CommonTable>
          </ModalBox>
        </section>
        <OperationLog
          ref="OperationLogRef"
          :scrollHeight="scrollHeight"
          :actionSn="sn"
          :type="docType"
          v-if="isDetail"
        />
      </div>
      <div class="content-overflow">
        <BottomBtns
          :isEdit.sync="isEdit"
          :isDetail="isDetail"
          :draftLoading="draftLoading"
          :saveLoading="saveLoading"
          :status="formData.status"
          @submit="onSubmit"
          @cancel="getDetailInfo"
          @back="backForm"
        />
      </div>
    </a-spin>
    <a-modal :title="$t('单据转换报告')" v-model="resultVisible" width="800px">
      <CommonTable
        :columns="resultColumns"
        :dataSource="resultList"
        :showPagination="false"
        :showSetting="false"
      >
        <template v-slot:no="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:status="{ record }">
          <span class="text-success" v-if="record.success">
            {{ $t('成功') }}
          </span>
          <span class="text-error" v-else>
            {{ $t('失败') }}
          </span>
        </template>
      </CommonTable>
      <template slot="footer">
        <a-button @click="resultVisible = false">{{ $t('关闭') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import SelectCurrency from '@component/selectCurrency'
import CommonSelect from '@component/commonSelect'
import CommonTable from '@component/commonTable'
import PushBtn from '@component/pushBtn'
import PriceInput from '@component/priceInput'
import { add, subtract } from '@/common/number'
import DatePicker from '@component/datePicker'
import BottomBtns from '@component/bottomBtns'
import deepClone from '@/common/deepClone'
import { convertKeysToCamelCase, goBack } from '@/common'
import OperationLog from '@component/operationLog'
import debounce from '@/common/debounce'
import CommonPayeeSelect from '@component/commonPayeeSelect'
import SelectDocumentType from '@component/selectDocumentType'

export default {
  name: 'paymentRequestDetail',
  components: {
    DatePicker,
    SelectCurrency,
    CommonSelect,
    CommonTable,
    BottomBtns,
    PushBtn,
    PriceInput,
    OperationLog,
    CommonPayeeSelect,
    SelectDocumentType,
  },
  data() {
    return {
      id: '',
      sn: '',
      docType: 'PaymentRequest',
      loading: false,
      visible: false,
      isCopy: false,
      isDetail: false, //是否是详情页
      isEdit: false, //是否编辑
      saveLoading: false,
      draftLoading: false,
      detailList: [],
      selectedRowKeys: [],
      formData: {
        amountWithoutTax: undefined,
        payableAmount: undefined,
        settlementCurrency: 'CNY',
        paymentCurrency: 'CNY',
        status: 'DRAFT',
        payeeType: 'SUPPLIER',
        payeeCode: undefined,
        payeeName: undefined,
      },
      purchaseAllQuantity: 0,
      purchaseAllAmount: 0,
      totalPayableAmount: 0,
      resultVisible: false,
      resultList: [],
    }
  },
  activated() {
    this.init()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data())
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  computed: {
    ...mapState(['payment_request_type', 'payment_purpose', 'contact_type']),
    ...mapGetters(['paymentRequestStatusMapping', 'currencySymbolMapping']),
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    columns() {
      let list = [
        {
          title: this.$t('付款用途'),
          align: 'center',
          dataIndex: 'paymentPurpose',
          width: 120,
          scopedSlots: {
            customRender: 'paymentPurpose',
          },
        },
        {
          title: this.$t('应付金额'),
          align: 'center',
          dataIndex: 'payableAmount',
          width: 150,
          scopedSlots: {
            customRender: 'payableAmount',
          },
        },
        {
          title: this.$t('申请金额'),
          align: 'center',
          dataIndex: 'applyAmount',
          width: 120,
          scopedSlots: {
            customRender: 'applyAmount',
          },
        },
        {
          title: this.$t('预计付款金额'),
          align: 'center',
          dataIndex: 'expectedPaymentAmount',
          width: 120,
          scopedSlots: {
            customRender: 'expectedPaymentAmount',
          },
        },
        {
          title: this.$t('到期日'),
          align: 'center',
          dataIndex: 'dueDate',
          width: 120,
          scopedSlots: {
            customRender: 'dueDate',
          },
        },
        {
          title: this.$t('结算方式'),
          align: 'center',
          dataIndex: 'settlementMethod',
          width: 120,
          scopedSlots: {
            customRender: 'settlementMethod',
          },
        },
      ]
      if (this.isDetail) {
        list.splice(
          -2,
          0,
          ...[
            {
              title: this.$t('已锁定金额'),
              dataIndex: 'lockAmount',
              customRender: (text) => this.showPrice(text),
            },
            {
              title: this.$t('未锁定金额'),
              dataIndex: 'unLockAmount',
              customRender: (text, record) =>
                this.showPrice(subtract(record.approvedAmount, record.lockAmount || 0)),
            },
          ]
        )
      }
      return list
    },
    scrollHeight() {
      let height = window.innerHeight - 280
      return height * this.$store.state.rate + 'px'
    },
    resultColumns() {
      return [
        {
          title: this.$t('源单数据'),
          dataIndex: 'orderSn',
        },
        {
          title: this.$t('下推状态'),
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: this.$t('消息'),
          dataIndex: 'desc',
        },
      ]
    },
    showTableList() {
      return this.detailList.filter((item) => item.showStatus !== -1)
    },
  },
  methods: {
    init() {
      this.isCopy = false
      this.isEdit = false
      this.isDetail = false
      this.selectedRowKeys = []
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.sn = this.$route.query.sn
        this.isDetail = true
        this.$nextTick(() => {
          this.$refs.OperationLogRef.queryList()
        })
      } else {
        Object.assign(this.$data, this.$options.data())
      }
      this.getDetailInfo()
    },
    showPrice(num) {
      if (num) {
        return this.$currencySymbol(num, this.formData.paymentCurrency)
      }
    },
    changeBU(value) {
      this.formData.businessUnitCode = value.code
      this.formData.businessUnitName = value.name
      this.formData.settlementCurrency = value.currency
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector('.fixContent').scrollTo(0, 2000)
      })
    },
    supplierIndexChange(val) {
      if (!this.formData.businessUnitCode) {
        this.formData.businessUnitCode = val.business_unit_code
        this.formData.businessUnitName = val.business_unit_name
      }
    },
    async getDetailInfo() {
      let paymentRequestFormdata = localStorage.getItem('paymentRequestFormdata'),
        pushTableList = localStorage.getItem('pushTableList')
      if (this.id) {
        this.loading = true
        let res = await http({
          url: api.getPaymentRequestDetail,
          type: 'post',
          data: {
            id: this.id,
          },
        })
        let result = convertKeysToCamelCase(res.result)
        this.detailList = deepClone(result.detailList)
        if (this.detailList.length === 0) {
          this.addLineHandle()
        }
        let formData = result
        this.formData = formData
        this.calcAllAmount()
        if (result.status === 'DRAFT') {
          this.isEdit = true
        }
      } else if (paymentRequestFormdata) {
        //复制
        this.isCopy = true
        let data = JSON.parse(paymentRequestFormdata)
        console.log(data)
        this.formData = data
        this.formData.paymentRequestSn = undefined
        this.formData.id = undefined
        this.formData.status = 'DRAFT'
        this.detailList = deepClone(this.formData.detailList)
        delete this.formData.detailList
        localStorage.removeItem('paymentRequestFormdata')
      } else if (pushTableList) {
        this.isCopy = true
        //应付单下推过来
        this.getFormData()
        let data = JSON.parse(pushTableList)
        this.detailList = deepClone(data)
        localStorage.removeItem('pushTableList')
        localStorage.removeItem('pushFormData')
        this.calcAllAmount()
      }
      this.loading = false
    },
    getFormData() {
      let pushFormData = JSON.parse(localStorage.getItem('pushFormData'))
      console.log('pushFormData: ', pushFormData)
      this.formData.payeeCode = pushFormData.payeeCode
      this.formData.payeeName = pushFormData.payeeName
      this.formData.businessUnitCode = pushFormData.businessUnitCode
      this.formData.businessUnitName = pushFormData.businessUnitName
      this.formData.settlementCurrency = pushFormData.settlementCurrency || 'CNY'
      this.formData.paymentCurrency = pushFormData.functionalCurrency || 'CNY'
      this.formData.dueDate = pushFormData.dueDate
    },
    chooseDate(data) {
      this.formData.applyTime = data.data
    },
    handleChange(value, record) {
      if (+value === 0) {
        value = ''
      }
      this.$set(record, 'applyAmount', value)
      this.$set(record, 'payableAmount', value)
      this.$set(record, 'expectedPaymentAmount', value)
      this.calcAllAmount()
    },
    calcAllAmount() {
      let applyAmount = 0,
        expectedPaymentAmount = 0
      this.detailList.forEach((item) => {
        applyAmount = add(applyAmount, item.applyAmount || 0)
        expectedPaymentAmount = add(expectedPaymentAmount, item.expectedPaymentAmount || 0)
      })
      this.formData.applyAmount = applyAmount
      this.formData.payableAmount = applyAmount
      this.formData.expectedPaymentAmount = expectedPaymentAmount
    },
    verification() {
      this.detailList.forEach((res, index) => {
        if (!res.paymentPurpose) {
          this.$warning({
            title: this.$t(`警告`),
            content: this.$t(`第X行请选择付款用途`, { X: index + 1 }),
          })
          throw Error()
        }
        if (!res.applyAmount) {
          this.$warning({
            title: this.$t(`警告`),
            content: this.$t(`第X行请填写申请金额`, { X: index + 1 }),
          })
          throw Error()
        }
      })
      return Promise.resolve()
    },
    backForm(back = 0) {
      goBack('paymentRequestList', back)
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    copyOrder() {
      this.formData.detailList = this.detailList
      let data = JSON.stringify(this.formData)
      localStorage.setItem('paymentRequestFormdata', data)
      this.$router.push('/payableManage/paymentRequestDetail')
    },
    chooseDueDate(record, data) {
      record.dueDate = data.data
    },
    onSubmit: debounce(async function (status) {
      if (status !== 'DRAFT') {
        if (!this.formData.payeeName) {
          this.$warning({
            title: this.$t(`警告`),
            content: this.$t(`请选择往来单位`),
          })
          return
        }
        if (!this.formData.applyAmount) {
          this.$warning({
            title: this.$t(`警告`),
            content: this.$t(`请填写请款金额`),
          })
          return
        }
        await this.verification()
      }
      const data = deepClone(this.formData)
      if (this.id) {
        data.id = this.id
      }
      data.status = status
      if (status === 'DRAFT') {
        this.draftLoading = true
      } else {
        this.saveLoading = true
      }
      data.detailList = deepClone(this.detailList).map((item) => {
        item.payeeType = this.formData.payeeType
        item.payeeCode = this.formData.payeeCode
        item.payeeName = this.formData.payeeName
        return item
      })
      data.merchantCode = localStorage.getItem('merchantCode')
      try {
        await http({
          url: api.createPaymentRequest,
          data: {
            paymentRequestReqVO: data,
          },
          type: 'post',
          hasLoading: true,
          success: (res) => {
            if (res.success) {
              this.$success({
                title: this.$t(`成功`),
                content: this.$t(`保存成功`),
              })
              if (this.isDetail) {
                this.init()
              } else {
                this.backForm()
              }
            } else {
              this.$error({
                title: this.$t(`错误`),
                content: this.$t(`创建失败`),
              })
            }
          },
        })
      } finally {
        this.draftLoading = false
        this.saveLoading = false
      }
    }),
    addLineHandle() {
      this.detailList.push({
        dueDate: moment().format('YYYY-MM-DD'),
      })
    },
    deleteLineHandle() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning(this.$t(`至少选中一项`))
        return
      }
      this.detailList
        .filter((item) => item.showStatus !== -1)
        .forEach((item, index) => {
          if (this.selectedRowKeys.includes(index)) {
            this.$set(item, 'showStatus', -1)
            item.payableAmount = 0
            item.applyAmount = 0
            item.expectedPaymentAmount = 0
          }
        })
      this.selectedRowKeys = []
      this.calcAllAmount()
    },
  },
}
</script>

<style lang="scss" scoped>
.statusBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form-table-heard:before {
  content: '*';
  color: red;
}

.form-content {
  padding: 20px 5%;
}
.ant-form-item {
  margin-bottom: 0;
}
.search-group {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 3px;
  .add {
    position: absolute;
    display: block;
    right: -45px;
  }
}
.goods-list {
  flex-wrap: wrap;
  .goods-item {
    line-height: normal;
    margin-right: 6px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
.node-modal {
  font-size: 15px;
  padding-top: 10px;
  text-align: center;
}
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.right-div {
  background-color: transparent;
  font-size: 12px;
  width: 300px;
  height: 591px;
  overflow: auto;
}
.formContentGoods {
  /* padding: 10px 15px; */
  margin-bottom: 16px;
  background-color: white;
  color: #333333;
  font-size: 14px;
}
.modalA ::v-deep .ant-modal-footer {
  border-top: 0px solid #e8e8e8;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.pricing-method {
  margin-bottom: 10px;
}
</style>
